module.exports = __webpack_public_path__ + "img/tutorial_five_nl.602f7026.png";